import { useState } from "react";
import { toastService } from "@services/ToastService";
import { conversationService } from "@services/ConversationService";

export const useConversation = () => {
  const [loading, setLoading] = useState(false);

  const fetchUserConversations = async () => {
    setLoading(true);
    try {
      const response = await conversationService.getUserConversations();
      return response || [];
    } catch (error) {
      console.error("Failed to fetch conversations", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const getConversationById = async (conversationId: number) => {
    try {
      return await conversationService.getConversationById(conversationId);
    } catch (error) {
      console.error("Failed to fetch conversation");
      throw error;
    }
  };

  const deleteConversation = async (conversationId: number) => {
    setLoading(true);
    try {
      await conversationService.deleteConversation(conversationId);
      toastService.success("Conversation deleted");
    } catch (error) {
      console.error("Failed to delete conversation");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    fetchUserConversations,
    getConversationById,
    deleteConversation,
  };
};
